import { TYPES, TYPE_ICONS } from 'constants/config';

export const adderOptions = {
  lesson: {
    label: t('common.lesson'),
    icon: 'lesson',
    value: TYPES.LESSON,
  },
  path: {
    label: t('common.path'),
    icon: 'path',
    value: TYPES.PATH,
  },
  placeholder: {
    label: t('common.placeholder'),
    icon: 'placeholder',
    value: TYPES.PLACEHOLDER,
  },
  waitStep: {
    label: t('common.wait_step'),
    icon: 'waitstep',
    value: TYPES.WAITSTEP,
  },
  certification: {
    label: t('common.certification'),
    icon: TYPE_ICONS.Certification,
    value: TYPES.CERTIFICATION,
  },
};

export const blankViewOptions = {
  lesson: {
    icon: 'lesson',
    value: TYPES.LESSON,
    title: t('paths.path_builder.blank_views.lesson.title'),
    description: t('paths.path_builder.blank_views.lesson.description'),
  },
  path: {
    icon: 'path',
    value: TYPES.PATH,
    title: t('paths.path_builder.blank_views.path.title'),
    description: t('paths.path_builder.blank_views.path.description'),
  },
  placeholder: {
    icon: 'placeholder',
    value: TYPES.PLACEHOLDER,
    title: t('paths.path_builder.blank_views.placeholder.title'),
    description: t('paths.path_builder.blank_views.placeholder.description'),
  },
  certification: {
    icon: TYPE_ICONS.Certification,
    value: TYPES.CERTIFICATION,
    title: t('paths.path_builder.blank_views.certification.title'),
    description: t('paths.path_builder.blank_views.certification.description'),
  },
};
